import { s4 } from '@ardoq/design-tokens';
import { POPOVER_Z_INDEX } from '@ardoq/popovers';
import { Select, SelectOption } from '@ardoq/select';
import styled from 'styled-components';
import { DEFAULT_ARDOQ_I18NLOCALE, I18nLocale, t } from '@ardoq/i18n';
import { AutocompleteFieldSuggestion } from './types';

export const AutocompleteFieldPopover = ({
  options,
  onClose,
  onValueChange,
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
}: {
  options?: SelectOption<AutocompleteFieldSuggestion>[];
  onClose: () => void;
  onValueChange: (suggestion: AutocompleteFieldSuggestion | null) => void;
  i18nLocale?: I18nLocale;
}) => (
  <Container>
    <Select
      autoFocus
      backspaceRemovesValue={false}
      controlShouldRenderValue={false}
      hideSelectedOptions={false}
      isClearable={false}
      menuIsOpen
      onMenuClose={onClose}
      onValueChange={onValueChange}
      options={options}
      placeholder={t(
        i18nLocale,
        'scopeData:calculatedFields.fieldSuggestionPlaceholder',
        'Select field...'
      )}
      tabSelectsValue={false}
    />
  </Container>
);

const Container = styled.div`
  position: absolute;
  z-index: ${POPOVER_Z_INDEX};
  padding-top: ${s4};
  width: 100%;
`;
